const HDE_EVENT_CALENDAR_API_ROUTE = '/remix-api/hde/event';

export function getHdeEventGoogleCalendarUrl(eventId: string): string {
    return `${HDE_EVENT_CALENDAR_API_ROUTE}/${eventId}/calendar/google`;
}
